<div class="surrender-application-container">
  <div class="container-body pb-3 pt-3">
    <div class="license-wrapper border-box mb-3">
        <div class="license-header d-flex justify-content-between align-items-center"
            (click)="ApplicationInstruction = !ApplicationInstruction" [ngClass]="{'expanded': ApplicationInstruction, 'collapsed': !ApplicationInstruction}">
            <h5 class=" mb-0">Application Instruction</h5>
            <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!ApplicationInstruction"
            (click)="$event.stopPropagation(); ApplicationInstruction = !ApplicationInstruction">
            <span class="toggle-icon">
                <i class="fas fa-chevron-up" *ngIf="ApplicationInstruction" aria-hidden="true"></i>
                <i class="fas fa-chevron-down" *ngIf="!ApplicationInstruction" aria-hidden="true"></i>
            </span>
            </button>
        </div>
        <div *ngIf="ApplicationInstruction" class="p-3 section-body border-box-section ">
            <div class="f-14 mb-3">
                Welcome to OPAL, the Nevada Department of Education’s Online Portal for Application and Licensure! This new system will allow you to apply for a license or endorsement, renew an existing license, clear a provision on an existing license, and update personal or contact information securely online.
            </div>
            <div class="f-14 mb-3">
                Once you apply and submit payment for a license or renewal, your receipt will be emailed to you, along with information on how to submit your fingerprints for a background check. You will continue to receive text message and email updates as your application moves through the review and approval process. When your background check clears and your application is approved, your official license will be sent to you via email.
            </div>
            <div class="f-14 mb-3">
                All applicants will be required to provide a copy of a valid government-issued photo ID. Licenses are issued with legal names and verification of legal name change will be required if any documents are under a name other than what is on the government-issued photo ID.
            </div>
            <div class="f-14 mb-3">
                Official hard copy transcripts can be sent via mail at the address provided on the Education tab of the application. If you mail in your transcripts, they must be original transcripts bearing the college or university seal. They do not have to be in a sealed envelope from the institution. Official electronic transcripts can be sent to transcripts@doe.nv.gov. Electronic transcripts will be accepted only if they are transmitted directly to the Department of Education from an accredited college or university if the institution is its own clearinghouse, or a recognized clearinghouse such as e-Script. Applicants may not email copies of their own transcripts. Test score reports and most other supporting documents may be uploaded within the online application.
            </div>
            <div class="f-14 mb-3">
                Applicants for a first-time license or renewal of a license must submit fingerprints for a background check pursuant to NRS 391.033. If you live in Nevada, you may submit your fingerprints electronically via Livescan. Applicants outside of Nevada who cannot submit prints via Livescan, and must submit a fingerprint card (FBI form FD-258) in person or by mail. Learn more about the 
                <a href="https://doe.nv.gov/educator-licensure/background-process/"  target="_blank"><u>fingerprinting and background process.</u></a>
            </div>
            <div class="f-14 mb-2">
                Additional information on the licensure process, as well as the minimum qualifications for licensure, may be found on our 
                <a href="https://doe.nv.gov/educator-licensure/" target="_blank"><u>website</u></a>.
            </div>
          </div>
    </div> 

    
    <div *ngIf="applicationData?.application_type == 'ARL (Alternative Route to Licensure)' || applicationData?.application_type == 'Substitute + ARL'"
     class="license-wrapper border-box mb-3">
        <div class="license-header d-flex justify-content-between align-items-center"
            (click)="Provider = !Provider" [ngClass]="{'expanded': Provider, 'collapsed': !Provider}">
            <h5 class=" mb-0">Provider</h5>
            <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!Provider"
            (click)="$event.stopPropagation(); Provider = !Provider">
            <span class="toggle-icon">
                <i class="fas fa-chevron-up" *ngIf="Provider" aria-hidden="true"></i>
                <i class="fas fa-chevron-down" *ngIf="!Provider" aria-hidden="true"></i>
            </span>
            </button>
        </div>
        <div *ngIf="Provider" class="p-3 section-body border-box-section ">
            <div class="justify-content-between d-flex">
                <form [formGroup]="providerForm" class="col-10 pl-0" novalidate>
                <div class="ml-1 row responsive-row ">
                    <div class="col-lg-4 col-md-6  pl-1 pr-0 d-flex flex-column responsive-col">
                    <div class="form-label">ARL Provider</div>
                    <div class="dropdown-clear-wrapper">
                        <p-dropdown  id="select_complainant_status"
                        formControlName="arlProvider" [autoDisplayFirst]="false"
                        [disabled]="true"  [options]="providerList" optionLabel="value" optionValue="key"
                            aria-required="false" 
                        tabindex="0" [attr.aria-describedby]="providerForm.get('arlProvider')?.invalid ? 'complaintArchivalStatus-error' : null"
                        />
                    </div> 
                    </div>
                </div>
                </form>
            </div>
        </div>
    </div> 
    <div class="license-wrapper border-box mb-3">
        <div class="license-header d-flex justify-content-between align-items-center"
            (click)="license = !license" [ngClass]="{'expanded': license, 'collapsed': !license}">
            <h5 class=" mb-0">Surrender Endorsement</h5>
            <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!license"
            (click)="$event.stopPropagation(); license = !license">
            <span class="toggle-icon">
                <i class="fas fa-chevron-up" *ngIf="license" aria-hidden="true"></i>
                <i class="fas fa-chevron-down" *ngIf="!license" aria-hidden="true"></i>
            </span>
            </button>
        </div>
         <div class="info-banner ml-3 mr-3">
         <span>
           For more information on qualifying endorsements and licensure details please view them
            <a target="_blank" href="https://doe.nv.gov/educator-licensure/available-licenses" class="info-link"><strong><u>here</u></  strong></a>.
        </span>

        </div>
        <div *ngIf="license" class="p-3 section-body border-box-section ">
          <div >
              <div class="ml-1 ">
                  <div class="pl-1 pr-0 d-flex flex-column responsive-col">
                  <app-data-grid [config]="surrenderEndorsementGrid"
                  id="surrender_license_kind" [actionsTemplateRef]="endorsementAction">
                      <ng-template #endorsementAction let-row let-index="index">
                          <div *ngIf="!viewOnly" class="action-buttons-container d-flex gap_action"
                              [id]="'endorsement_actions_'">
                              <div *ngIf="applicationStatus == 'In Progress,Not Submitted'"  class="action-inline ml-4">
                                  <div *ngIf="row.cd_endo_status ==='Active'" class="action-flex hover-action">
                                      <button  mat-icon-button type="button" class="action-icon-button request-colour" matTooltip="Request Surrender" matTooltipPosition="above" 
                                      matTooltipClass="custom-tooltip" (click)="requestLicenseSurrender(row,'endorseRequest')" [disabled]="viewOnly">
                                          <img src="../../assets/images/neveda-images/request_surrender.svg" alt="Request Surrender" width="24"
                                          height="24" class="icon default-icon">
                                          <img src="../../assets/images/neveda-images/request_surrender_coloured.svg" alt="Request Surrender" width="24"
                                          height="24" class="icon hover-icon">
                                      </button>
                                  </div>
                                  <div *ngIf="row.cd_endo_status ==='Surrender Requested'" class="action-flex hover-action">
                                      <button type="button" class="action-icon-button" matTooltip="Cancel Surrender Request" matTooltipPosition="above" 
                                      matTooltipClass="custom-tooltip"  (click)="cancelSurrender(row,'endorseRequest')" [disabled]="viewOnly">
                                          <img src="../../assets/images/neveda-images/cancel_request_surrender.svg" alt="Cancel Surrender Request" width="24"
                                          height="24" class="icon default-icon">
                                          <img src="../../assets/images/neveda-images/cancel_request_surrender_coloured.svg" alt="Cancel Surrender Request" width="24"
                                          height="24" class="icon hover-icon">
                                      </button>
                                  </div>
                              </div>
                                <div *ngIf="applicationStatus === 'Analyst Pending' && row.cd_endo_status ==='Surrender Requested' && surrenderFlow ==='analystSurrender'" class="action-inline row">
                                  <div *ngIf="row.decisionFlag === null || row.decisionFlag == false" class="action-flex hover-action">
                                      <button type="button" class="action-icon-button ml-2" matTooltip="Approve Surrender Request" matTooltipPosition="above" 
                                      matTooltipClass="custom-tooltip" (click)="actionLicenseSurrender(row,'endorseRequest','approve')" [disabled]="viewOnly">
                                          <img src="../../assets/images/neveda-images/Approved.svg" alt="Approve Surrender" width="24"
                                          height="24" class="icon default-icon">
                                          <img src="../../assets/images/neveda-images/Approved_coloured.svg" alt="Approve Surrender" width="24"
                                          height="24" class="icon hover-icon">
                                      </button>
                                  </div>
                                  <div *ngIf="row.decisionFlag === null || row.decisionFlag == true" class="action-flex hover-action">
                                      <button type="button" class="action-icon-button ml-2" matTooltip="Deny Surrender Request" matTooltipPosition="above" 
                                      matTooltipClass="custom-tooltip"  (click)="actionLicenseSurrender(row,'endorseRequest','deny')" [disabled]="viewOnly">
                                          <img src="../../assets/images/neveda-images/Denied.svg" alt="Deny Surrender Request" width="24"
                                          height="24" class="icon default-icon">
                                          <img src="../../assets/images/neveda-images/Denied_coloured.svg" alt="Deny Surrender Request" width="24"
                                          height="24" class="icon hover-icon">
                                      </button>
                                  </div>
                                  <div *ngIf="((row.decisionFlag === false || row.decisionFlag == true) && row.action_notes != null)" class="action-flex">
                                      <button mat-icon-button class="action-icon-button ml-2" matTooltip="Edit Analyst Communication"
                                          matTooltipPosition="above" matTooltipClass="custom-tooltip" [disabled]="viewOnly"
                                          [id]="'surrender_notes_edit_row_' + row.index" (click)="actionModalPopup(row,true,false,'endorseRequest')">
                                          <img src="../../assets/images/neveda-images/edit-icon.svg" alt="Edit" width="24"
                                          height="24" class="filter-icon">
                                      </button>
                                  </div>
                              </div>
                          </div>
                      </ng-template>
                  </app-data-grid>
                  </div>
              </div>
          </div>
        </div>
    </div>
    
    <!-- Notes start -->
    <div *ngIf="surrenderFlow ==='analystSurrender'" class="license-wrapper border-box" >
        <div class="license-header d-flex justify-content-between align-items-center"
            (click)="Notes = !Notes"
            [ngClass]="{'expanded': Notes, 'collapsed': !Notes}">
            <h5 class=" mb-0">Internal Notes</h5>
            <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!Notes"
            (click)="$event.stopPropagation(); Notes = !Notes">
            <span class="toggle-icon">
                <i class="fas fa-chevron-up" *ngIf="Notes" aria-hidden="true"></i>
                <i class="fas fa-chevron-down" *ngIf="!Notes" aria-hidden="true"></i>
            </span>
            </button>
        </div>
        <div *ngIf="Notes" class="p-3 section-body border-box-section ">
            <div class="mb-3">
                <form [formGroup]="surrenderNotesForm" class="pl-0" novalidate>
                <div class="responsive-row ">
                    <div class="col-lg-6 col-md-6  pl-1 pr-0 d-flex flex-column responsive-col">
                    <div class="form-label">Section</div>
                    <div class="dropdown-clear-wrapper">
                        <p-dropdown  id="select_complaint_notes_section"
                        formControlName="surrenderNotesSection" [options]="surrenderNotesSectionList" 
                        [autoDisplayFirst]="false" [placeholder]="placeholderMessage['P0099']"
                        styleClass="custom-dropdown-border form-control"
                            aria-required="false" [disabled]="true"
                        tabindex="0" [attr.aria-describedby]="surrenderNotesForm.get('surrenderNotesSection')?.invalid ? 'complaintNotesSection-error' : null"
                        [ngClass]="{'placeholder-color':surrenderNotesForm.get('surrenderNotesSection')?.value === null ,
                        'selected-color':surrenderNotesForm.get('surrenderNotesSection')?.value !== null,}" />
                    </div>
                    <div *ngIf="surrenderNotesForm.get('surrenderNotesSection')?.invalid && (surrenderNotesForm.get('surrenderNotesSection')?.touched || surrenderNotesForm.get('surrenderNotesSection')?.dirty)"
                        class="text-danger mt-1 err-font">{{ errorMessage['M0136'] }}</div>
                    </div>
                    </div>
                    <div class="form-group position-relative mt-3">
                        <label for="input_fingerprint_form_note">Notes <span class="text-danger">*</span> </label>
                        <textarea type="text" id="input_fingerprint_form_note" formControlName="surrenderNotesTextData" [disabled]="viewOnly"
                            class="form-control" rows="3" placeholder="{{placeholderMessage['P0089']}}" maxlength="4000"
                            [ngClass]="{ 'is-invalid': surrenderNotesForm.get('surrenderNotesTextData')?.invalid && surrenderNotesForm.get('surrenderNotesTextData')?.touched }"></textarea>
                        <div *ngIf="surrenderNotesForm.get('surrenderNotesTextData')?.touched && surrenderNotesForm.get('surrenderNotesTextData')?.errors?.['required']"
                        class="text-danger mt-1 err-font">{{ errorMessage['M0126'] }}</div>
                    </div>
                    <div class="d-flex justify-content-end licenseactions pl-3 mt-3">
                    <button class="btn-cancel btn text-right py-1 height_btn" tooltipPosition="bottom"
                        (click)="resetNotesData()" [disabled]="!notesFormTouched || viewOnly">Reset</button>
                    <button type="button" class="btn btn-primary grid rounded btn-add height_btn"
                        [disabled]="viewOnly"  aria-label="Add" tooltipPosition="bottom"
                        (click)="addNotesData()"> 
                        <i class="pi pi-plus-circle"></i> Add</button>
                    </div>
                </form>
            </div>
            <app-data-grid id="SurrenderNotesGrid" [config]="surrenderNotesGridConfig"
                [actionsTemplateRef]="SurrenderNotesActionsTemplate">
            <ng-template #SurrenderNotesActionsTemplate let-row let-index="index">
                <div class="action-buttons-container"
                [id]="'dashboard_div_actions_' + row.index">
                <span *ngIf="applicationStatus == 'Analyst Pending' && !viewOnly" class="action-span-wrapper">
                    <button mat-icon-button class="action-icon-button ml-2" matTooltip="Edit"
                        matTooltipPosition="above" matTooltipClass="custom-tooltip" [disabled]="viewOnly"
                        [id]="'surrender_notes_edit_row_' + row.index" (click)="notesModal(row,true,false)">
                        <img src="../../assets/images/neveda-images/edit-icon.svg" alt="Edit" width="24"
                        height="24" class="filter-icon">
                    </button>
                </span>
                <span class="action-span-wrapper">
                    <button mat-icon-button class="action-icon-button ml-2" matTooltip="View"
                        matTooltipPosition="above" matTooltipClass="custom-tooltip"
                        [id]="'surrender_notes_view_row_' + row.index" (click)="notesModal(row,false,true)">
                        <img src="../../assets/images/neveda-images/eye.svg" alt="View" width="24"
                        height="24" class="filter-icon">
                    </button>
                </span>
                <span *ngIf="applicationStatus == 'Analyst Pending' && !viewOnly" class="action-span-wrapper">
                    <button  mat-icon-button class="action-icon-button ml-2" matTooltip="Delete"
                        matTooltipPosition="above" matTooltipClass="custom-tooltip" [disabled]="viewOnly"
                        [id]="'surrender_notes_delete_row_' + row.index" (click)="deleteNotesRow(row)">
                        <img src="../../assets/images/neveda-images/delete-icon.svg" alt="Delete" width="24"
                        height="24" class="filter-icon">
                    </button>
                </span>
                </div>
            </ng-template>
            </app-data-grid>
        </div>
    </div>
    <!-- Notes end-->
     <!--acknowledgement start-->
     <div class="license-wrapper border-box mb-3" >
        <div class="license-header d-flex justify-content-between align-items-center"
            (click)="acknowledgement = !acknowledgement" [ngClass]="{'expanded': acknowledgement, 'collapsed': !acknowledgement}">
            <h5 class=" mb-0">Acknowledgement</h5>
            <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!acknowledgement"
            (click)="$event.stopPropagation(); acknowledgement = !acknowledgement">
            <span class="toggle-icon">
                <i class="fas fa-chevron-up" *ngIf="acknowledgement" aria-hidden="true"></i>
                <i class="fas fa-chevron-down" *ngIf="!acknowledgement" aria-hidden="true"></i>
            </span>
            </button>
        </div>         
        <div *ngIf="acknowledgement" class="p-3 section-body border-box-section">
            <div class="row">
              <div class="col-12">
                <p class="mb-2">
                  By typing your full name below, you are electronically signing this application and certifying that
                  the information provided is true and complete to the best of your knowledge.
                </p>
              </div>
            </div>
            <form [formGroup]="applicationForm">
            <div class="row mb-2">
              <div class="col-md-5">
                <div class="form-label">Signature – Applicant's Full Name 
                    <!-- <i data-tooltip="First and last name only. Do not include middle name or suffix." class="fa fa-question-circle text-muted" tabindex="0" ref="tooltip" aria-expanded="false"></i> -->
                  
                  <button mat-icon-button class="action-icon-button info-button" matTooltip="First and last name only. Do not include middle name or suffix." matTooltipPosition="right" 
                    matTooltipClass="acknowledgementSign-tooltip">
                          <i class="fa fa-question-circle text-muted" tabindex="0"  aria-expanded="false"></i>
                    </button>
                    <span class="text-danger">*</span>
                </div>
                <div class="input-wrapper" [ngClass]="{'application-valid-tick': (applicationForm.get('acknowledgementSign')?.valid ||
                applicationForm.get('acknowledgementSign')?.disabled)
                && !signatureError}">
                <input formControlName="acknowledgementSign"
                  type="text" (input)="formatInput($event)"
                  class="form-control" [disabled]="viewOnly"
                  placeholder="{{placeholderMessage['P0045']}}"
                 [ngClass]="{'is-invalid-error':signatureError, 'signfont': applicationForm.get('acknowledgementSign')?.value}"/>
                 </div>
                <span class="mt-2">Please sign using the <strong>Educator Name</strong> listed in the header of your application</span>
                <div *ngIf="applicationForm.get('acknowledgementSign')?.invalid && (applicationForm.get('acknowledgementSign')?.touched || applicationForm.get('acknowledgementSign')?.dirty)"
                            class="text-danger mt-1 err-font">{{ errorMessage['M0069'] }}</div>
                <div *ngIf="signatureError && applicationForm.get('acknowledgementSign')?.valid "
                            class="text-danger mt-1 err-font">{{ errorMessage['M0068'] }}</div>
              </div>
            </div>
            </form>
        </div>
    </div>
    <!--acknowledgement end-->
    <hr>
    <div class="d-flex justify-content-end">
        <button *ngIf="applicationStatus == 'In Progress,Not Submitted'" type="submit" class="btn btn-primary float-md-right mb-3 rounded responsive-submit-btn"
        [disabled]="applicationForm?.invalid || signatureError || !surrenderRequested()" 
        (click)="submitApplication()">Submit Application</button>
        <!-- <button *ngIf="surrenderFlow ==='analystSurrender' && applicationStatus == 'Analyst Pending'" type="submit" class="btn btn-primary float-md-right mb-3 rounded responsive-submit-btn"
        (click)="closeApplication()"><span *ngIf="!previewCommunication()" [disabled]="!finalCommunication()">{{finalCommunication()}} Issue Final Determination</span>
        <span *ngIf="previewCommunication()">Preview Communication</span>
      </button> -->
      <div *ngIf="surrenderFlow ==='analystSurrender' && applicationStatus == 'Analyst Pending'" >
        <button  *ngIf="!previewCommunication()"  type="submit"  class="btn btn-primary float-md-right mb-3 rounded responsive-submit-btn"
           (click)="closeApplication()" [disabled]="viewOnly">Issue Final Determination</button>
        <button  *ngIf="previewCommunication()"  type="submit"  class="btn btn-primary float-md-right mb-3 rounded responsive-submit-btn"  
        (click)="closeApplication()"  [disabled]="viewOnly">Preview Communication</button>
      </div>
    </div>
  </div>
  <hr class="mb-2" />
  <div class="mb-5">
    <button class="btn btn-primary float-right " (click)="moveToNext()">
        <span class="fas fa-arrow-right"></span> Next
    </button>
  </div>
</div>
<!-- Delete Modal -->
<ng-template #showDeleteModal let-modal>
<div  class="custom-ngb-modal deletemodal" id="dashboard_delete_modal">
  <div class="modal-header">
    <h6 class="w-100 text-start font-weight-bold mb-0">Delete Note</h6>
    <div>
          <img src="assets/images/neveda-images/close.svg" id="close_img" (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()" alt="close_icon" tabindex="0">
        </div>
    </div>
    <div class="modal-body mb-2 pb-0">
        <div class="font-14">Are you sure you want to delete this note? This action cannot be undone.</div>
      </div>
    <div class="modal-footer">
      <div class="flex-fill">
        <button class="btn w-50 btn-outline" (click)="closeDeleteModal()">Cancel</button>
        <button class="btn w-50 btn-danger btn-radius" (click)="confirmDeleteRow()">Delete</button>
      </div>
    </div>
</div>
</ng-template>

<!--submit application-->
<ng-template #showSubmitModal let-modal>
  <div class="custom-ngb-modal">
      <div class="modal-header d-flex justify-content-between align-items-center pb-0">
        <h4 class="fw-bold  m-0">Submit Application</h4>
        <div class="btn-modal-close cursor-pointer">
          <img src="assets/images/neveda-images/close.svg" id="close_img" (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()" alt="close_icon" tabindex="0" class="mb-4 filternone">
        </div>
      </div>
      <div class="modal-body mb-2 pb-0">
        <div class="f-14 mb-2">You are about to submit this application for review.</div>
        <div class="f-14 mb-2"> Once submitted, the application will enter the review process.</div>
        <div class="f-14">Do you wish to continue?</div> 
      </div>
        <hr>  
        <div  class="d-flex  pl-3 mt-3 mb-3 pr-4">
          <button class="btn-cancel col-6 btn text-right text-center height_btn" tooltipPosition="bottom" 
             (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()">Return to Application</button>
          <button type="button" class="btn btn-primary grid col-6 rounded btn-add height_btn"
            aria-label="Update" tooltipPosition="bottom" (click)="confirmSubmit()">
            Confirm Submission</button>
        </div>
  </div>
</ng-template>
<!--Final Determination-->
<ng-template #showFinalDetermination let-modal>
  <div class="custom-ngb-modal">
      <div class="modal-header d-flex justify-content-between align-items-center pb-0">
        <h4 class="fw-bold  m-0">Confirm Final Determination</h4>
        <div class="btn-modal-close cursor-pointer">
          <img src="assets/images/neveda-images/close.svg" id="close_img" (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()" alt="close_icon" tabindex="0" class="mb-4">
        </div>
      </div>
      <div class="modal-body mb-2 pb-0">
        <div class="f-14 mb-2">Are you sure you want to issue the final determination and close this application?</div>
        <div class="f-14 mb-2">All endorsement surrender requests have been approved and will be removed from the licensee’s record.</div>
        <div class="f-14">Please ensure all reviews and validations are complete before proceeding.</div> 
      </div>
        <hr>  
        <div  class="d-flex  pl-3 mt-3 mb-3 pr-4">
          <button class="btn-cancel col-6 btn text-right text-center height_btn" tooltipPosition="bottom" 
             (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()">Return to Application</button>
          <button type="button" class="btn btn-primary grid col-6 rounded btn-add height_btn"
            aria-label="Update" tooltipPosition="bottom" (click)="confirmFinalDetermination()">
            Proceed</button>
        </div>
  </div>
</ng-template>
<!--Preview Communication-->
<ng-template #previewCommunicationModal let-modal>
  <div class="custom-ngb-modal">
      <div class="modal-header d-flex justify-content-between align-items-center pb-0">
        <span class="font-weight-600 f-18  m-0">Preview Communication</span>
        <div class="btn-modal-close cursor-pointer">
          <img src="assets/images/neveda-images/close.svg" id="close_img" (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()" alt="close_icon" tabindex="0" class="mb-4">
        </div>
      </div>
      <div class="modal-body mb-2 pb-0">
        <h5 class="text-center"><img src="../../assets/images/NDE-logo_text.svg" alt="NDE LOGO" width="60"
                                          height="60" class="icon default-icon">
          <strong>Online Portal for Application and Licensure(OPAL)</strong></h5>
        <p class="mb-2 f-14">{{todayDate | date:'dd/MM/yyyy'}}</p>
        <p class="mb-2 f-14">Dear {{personData.person_name}}</p>
        <p class="mb-3 f-14">Your application to surrender one or more of your endorsements 
          has been denied for the following reason(s):</p>
        <div  *ngFor="let endorse of filteredEndorsementData; let i=index">
            <div class="f-14 fw-bold text-black">{{i+1}}.{{endorse.endorsements}} - <div class="notes-display" [innerHTML]="formatQuillContent(endorse.action_notes)"></div></div>
        </div>
        <p class="mt-3 mb-2 f-14">If you need to submit a new application to surrender after reviewing the 
          information above, you can do so in your portal.</p>
        <div class="mb-2 f-14">
          <span>Thank you,</span><br>
          <span class="mt-2">{{getUserFullName()}}</span><br>
          <span>Office of Educator Licensure</span><br>
          <span>Nevada Department of Education</span>
        </div>
      </div>
        <hr>  
        <div  class="d-flex  pl-3 mt-3 mb-3 pr-4">
          <button class="btn-cancel col-6 btn text-right text-center height_btn" tooltipPosition="bottom" 
             (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()">Return to Application</button>
          <button type="button" class="btn btn-primary grid col-6 rounded btn-add height_btn"
            aria-label="Update" tooltipPosition="bottom" (click)="confirmFinalDetermination()">
            Publish</button>
        </div>
  </div>
</ng-template>

<ng-template #NotesModal let-modal>
  <div class="custom-ngb-modal">
    <form [formGroup]="editSurrenderNotesForm" class="pl-0" novalidate>
      <div class="modal-header d-flex justify-content-between align-items-center pb-0">
        <h4 *ngIf="isViewNotes" class="fw-bold m-0">View Note</h4>
        <h4 *ngIf="isEditNotes" class="fw-bold m-0">Edit Note</h4>
        <div>
          <img src="assets/images/neveda-images/close.svg" id="close_img" (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()" alt="close_icon" tabindex="0">
        </div>
      </div>
      <div class="modal-body mb-3 pb-0">
      <div class="row responsive-row ">
        <div class="col-lg-10 col-md-10 pl-1 pr-0 d-flex flex-column responsive-col">
          <div class="form-label">Section <span class="text-danger">*</span></div>
          <div class="dropdown-clear-wrapper">
            <p-dropdown  id="select_complaint_notes_section"
              formControlName="editNotesSection" [options]="surrenderNotesSectionList"
              [autoDisplayFirst]="false" [placeholder]="placeholderMessage['P0099']"
              styleClass="custom-dropdown-border form-control"
                aria-required="false" [disabled]="true"
              tabindex="0" [attr.aria-describedby]="editSurrenderNotesForm.get('editNotesSection')?.invalid ? 'editNotesSection-error' : null"
               [ngClass]="{'placeholder-color':editSurrenderNotesForm.get('editNotesSection')?.value === null ,
                        'selected-color':editSurrenderNotesForm.get('editNotesSection')?.value !== null,}"   />
          </div>
        </div>
        </div>
        <div class="form-group position-relative mt-3">
            <label for="input_surrender_form_note">Notes <span class="text-danger">*</span></label>
            <textarea type="text" id="input_surrender_form_note" formControlName="editNotesTextData"
              class="form-control" rows="3" placeholder="{{placeholderMessage['P0089']}}" maxlength="4000"
              [ngClass]="{ 'is-invalid': editSurrenderNotesForm.get('editNotesTextData')?.invalid && editSurrenderNotesForm.get('editNotesTextData')?.touched }"></textarea>
            <div *ngIf="editSurrenderNotesForm.get('editNotesTextData')?.touched && editSurrenderNotesForm.get('editNotesTextData')?.errors?.['required']"
              class="text-danger mt-1 err-font">
              Notes is required.
            </div>
        </div>
      </div>
      <div class="modal-footer border-top d-flex gap-2">
          <div *ngIf="isEditNotes">
          <button class="btn-cancel btn btn-primary btn-lg py-2 px-4" tooltipPosition="bottom" [disabled]="viewOnly"
            (click)="resetEditModal()" >Reset</button>
          <button type="button" class="btn btn-primary btn-lg btnprimary"
            (click)="updateNotesData()" aria-label="Update" tooltipPosition="bottom">
            Update</button>
          </div>
          <div *ngIf="isViewNotes">
            <button class="btn-cancel btn text-right py-1 height_btn" tooltipPosition="bottom"
            (click)="closeViewNotesModal()" >Close</button>
          </div>
        </div>
    </form>
  </div>
</ng-template>
<ng-template #RequestSurrender let-modal>
  <div class="custom-ngb-modal">
    <form [formGroup]="requestSurrenderForm" class="pl-0" novalidate>
      <div class="modal-header d-flex justify-content-between align-items-center pb-0">
        <span *ngIf="requestType === 'licenseRequest'" class="font-weight-600 f-18  m-0">Surrender License Kind</span>
        <h4 *ngIf="requestType === 'endorseRequest'" class="fw-bold  m-0">Surrender Endorsement</h4>
        <div class="btn-modal-close cursor-pointer">
          <img src="assets/images/neveda-images/close.svg" id="close_img" (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()" alt="close_icon" tabindex="0" class="mb-4">
        </div>
      </div>
      <div *ngIf="requestType === 'licenseRequest'" class="modal-body mb-3 pb-0">
        <span class="fw-300 f-14">Please provide a brief reason for requesting the surrender of <strong class="fw-600">{{selectedLicenseKind}}</strong>.</span>
         <div class="form-group position-relative mt-3">
            <textarea type="text" formControlName="licenseSurrenderNotes"
                    class="form-control mb-3" rows="3" placeholder="{{placeholderMessage['P0089']}}" maxlength="4000"></textarea>
            <div *ngIf="requestSurrenderForm.get('licenseSurrenderNotes')?.invalid && (requestSurrenderForm.get('licenseSurrenderNotes')?.touched || requestSurrenderForm.get('licenseSurrenderNotes')?.dirty)"
                            class="text-danger mt-1 err-font">{{ errorMessage['M0126'] }}</div>
        </div>
        <span class="fw-300 f-14 mb-2">If this is your only License Kind, your license will become inactive upon approval.</span><br><br>
        <span class="fw-300 f-14">If approved, the endorsements, provisions, and requirements associated with <strong class="fw-600">{{selectedLicenseKind}}</strong> will not apply at renewal unless they are reinstituted prior to renewal.
            Standard fees will apply if you later request reinstitution of <strong class="fw-600">{{selectedLicenseKind}}</strong> or its endorsements.</span>
        <div  class="d-flex justify-content-end licenseactions pl-3 mt-3">
          <button class="btn-cancel btn text-right py-1 height_btn" tooltipPosition="bottom" 
             (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()">Cancel</button>
          <button type="button" class="btn btn-primary grid rounded btn-add height_btn"
            aria-label="Update" tooltipPosition="bottom" (click)="updateLicenseSurrender()"
            [disabled]="requestSurrenderForm.invalid">
            Proceed</button>
        </div>
      </div>
      <div *ngIf="requestType === 'endorseRequest'" class="modal-body mb-3 pb-0">
        <span class="fw-300 f-14">Please provide a brief reason for requesting the surrender of <strong class="fw-600">{{selectedEndorseKind}}</strong>.</span>
         <div class="form-group position-relative mt-3">
            <textarea type="text" formControlName="endoSurrenderNotes"
                    class="form-control mb-3" rows="3" placeholder="{{placeholderMessage['P0089']}}" maxlength="4000"></textarea>
            <div *ngIf="requestSurrenderForm.get('endoSurrenderNotes')?.invalid && (requestSurrenderForm.get('endoSurrenderNotes')?.touched || requestSurrenderForm.get('endoSurrenderNotes')?.dirty)"
                            class="text-danger mt-1 err-font">{{ errorMessage['M0126'] }}</div>
        </div>
        <span class="fw-300 f-14">If this is the only endorsement under <strong class="fw-600">{{selectedLicenseKind}}</strong>, surrendering it will also remove the License Kind. If <strong class="fw-600">{{selectedLicenseKind}}</strong> is the only License Kind on your license, your license will become inactive upon approval.</span><br><br>
        <span class="fw-300 f-14">If approved, the provisions and requirements associated with <strong class="fw-600">{{selectedEndorseKind}}</strong> will not apply at renewal unless it is reinstituted prior to renewal. Standard fees will apply if you later request reinstitution of <strong class="fw-600">{{selectedEndorseKind}}</strong>, its License Kind, or associated endorsements.</span>
        <div  class="d-flex justify-content-end licenseactions pl-3 mt-3">
          <button class="btn-cancel btn text-right py-1 height_btn" tooltipPosition="bottom" 
             (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()">Cancel</button>
          <button type="button" class="btn btn-primary grid rounded btn-add height_btn"
            aria-label="Update" tooltipPosition="bottom" (click)="updateEndorseSurrender()"
            [disabled]="requestSurrenderForm.invalid">
            Proceed</button>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #CancelSurrender let-modal>
  <div class="custom-ngb-modal">
      <div class="modal-header d-flex justify-content-between align-items-center pb-0">
        <h4 class="fw-bold  m-0">Cancel Surrender Request</h4>
        <!-- <h4 *ngIf="isEditNotes" class="fw-bold m-0">Edit Note</h4> -->
        <div class="btn-modal-close cursor-pointer">
          <img src="assets/images/neveda-images/close.svg" id="close_img" (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()" alt="close_icon" tabindex="0" class="mb-4">
        </div>
      </div>
      <div class="modal-body mb-3 pb-0">
        <span class="fw-300 f-14">Are you sure you want to cancel the surrender request for <strong *ngIf="requestType == 'licenseRequest'" class="fw-600">{{selectedLicenseKind}}</strong>
            <strong *ngIf="requestType == 'endorseRequest'" class="fw-600">{{selectedEndorseKind}}</strong>?</span>
        <div  class="d-flex justify-content-end licenseactions pl-3 mt-3">
          <button class="btn-cancel btn text-right py-1 height_btn" tooltipPosition="bottom" 
             (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()">Cancel</button>
          <button *ngIf="requestType == 'licenseRequest'" type="button" class="btn btn-primary grid rounded btn-add height_btn"
            aria-label="Update" tooltipPosition="bottom" (click)="updateCancelLicenseSurrender()">
            Proceed</button>
        <button *ngIf="requestType == 'endorseRequest'" type="button" class="btn btn-primary grid rounded btn-add height_btn"
            aria-label="Update" tooltipPosition="bottom" (click)="updateCancelEndorseSurrender()">
            Proceed</button>
        </div>
      </div>
  </div>
</ng-template>

<!--Action Modal-->
<ng-template #actionModal let-modal>
  <div class="custom-ngb-modal">
    <form [formGroup]="actionSurrender" class="pl-0" novalidate>
      <div class="modal-header">
        <h4 *ngIf="actionType == 'approve'" class="fw-bold m-0">Approve Surrender Request</h4>
        <h4 *ngIf="actionType == 'deny'" class="fw-bold m-0">Deny Surrender Request</h4>
        <div>
          <img src="assets/images/neveda-images/close.svg" id="close_img" (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()" alt="close_icon" tabindex="0">
        </div>
      </div>
      <div class="modal-body mb-3 pb-0">
        <span class="fw-300 f-14">Are you sure you want to <span *ngIf="actionType == 'approve'">approve</span>
        <span *ngIf="actionType == 'deny'">deny</span> the surrender of 
            <strong *ngIf="requestType == 'endorseRequest'" class="fw-600">{{selectedEndorseKind}}</strong>?</span>
        <div class="form-group position-relative mt-3">
            <label>Analyst Communication<span *ngIf="actionType == 'deny'" class="text-danger">*</span></label>
                <p-editor #analystCommunicationEditor 
                  [placeholder]="placeholderMessage['P0089']"
                  formControlName="actionSurrenderNotes"
                  (onInit)="onEditorInit($event)"
                  (onTextChange)="onEditorChange($event)"
                   [style]="{'height':'8rem'}"
                  >
                </p-editor>
            <div *ngIf="actionSurrender.get('actionSurrenderNotes')?.invalid && (actionSurrender.get('actionSurrenderNotes')?.touched || actionSurrender.get('actionSurrenderNotes')?.dirty) "
                            class="text-danger mt-1 err-font">{{ errorMessage['M0126'] }}</div>
        </div>
      </div>
      <div class="modal-footer border-top d-flex gap-2">
          <button class="btn-cancel btn btn-primary btn-lg py-2 px-4" tooltipPosition="bottom" 
             (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()">Cancel</button>
          <button  type="button" class="btn btn-primary btn-lg btnprimary"
            aria-label="Update" tooltipPosition="bottom" [disabled]="actionSurrender.invalid"
            (click)="proceedAction()" (keypress)="proceedAction()">
            Proceed</button>
      </div>
    </form>
  </div>
</ng-template>
